import createNavigation from "components/masthead/helpers/create_navigation";
import "./component.scss";

const { initDesktopNavigation, initMobileNavigation } = createNavigation({
  containerSelector: ".js-masthead-sports-navigation",
  navigationLinkSelector: ".js-masthead-sports-navigation-link",
  navigationContentSelector: ".js-masthead-sports-navigation-content",
  activeLinkClassName: "masthead-sports-navigation__section--active",
  slideSelector: ".js-masthead-sports-slide",
  slideLinkSelector: ".js-masthead-sports-slide-link",
  expandedSlideClassName: "masthead-sports-navigation__slide--expanded",
  backSelector: '.js-mobile-submenu-trigger[data-direction="back"]',
  mouseleaveCategory: "Sports",
  mobileBackMode: "level-based"
});

export { initDesktopNavigation, initMobileNavigation };
